import {Box, Modal, Text} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import Image from 'next/image';
import type {FC} from 'react';
import {MdDownload, MdPhoneIphone} from 'react-icons/md';
import {
  APP_STORE_QR_CODE_IMAGE,
  NEW_LOGO_IMAGE_PATH_APP_ICON,
} from '../../config/constants/img';
import {URL_TO_APPS_FLYER_ONE_LINK} from '../../config/constants/routes';
import {useMediaQuery} from '../services/useMediaQuery';
import {CommonLink} from './CommonLink';

export const AppPromoQR: FC = () => {
  const {isPC} = useMediaQuery();
  const [opened, {open, close}] = useDisclosure(false);

  return (
    <>
      <div className="mt-12 pc:my-0 pc:mx-0 mx-16 pc:pt-20 pc:bg-background-1">
        <div className="relative overflow-hidden mx-auto pc:my-0 pc:max-w-[1200px] py-12 px-16 bg-white rounded-[8px] shadow-card">
          {isPC ? (
            <Box className="flex flex-row items-center justify-between">
              <Box className="flex flex-row items-center gap-4 text-base text-black">
                <MdPhoneIphone size={20} />
                <Text>
                  アプリをダウンロードして最新情報をいち早くキャッチしよう！
                </Text>
              </Box>
              <button
                type="button"
                className="flex items-center justify-center gap-4 py-8 px-12 border-2 border-primary bg-primary rounded-full text-sm text-white font-bold cursor-pointer hover:opacity-60"
                onClick={open}
              >
                <MdDownload size={16} />
                アプリを入手
              </button>
            </Box>
          ) : (
            <Box className="flex flex-row items-center justify-between gap-8 text-xs">
              <MdPhoneIphone size={20} className="text-black" />
              <Text className="text-black">アプリでより便利に</Text>
              <CommonLink
                href={URL_TO_APPS_FLYER_ONE_LINK}
                className="flex items-center justify-center gap-4 py-8 px-12 border-2 border-primary bg-primary rounded-full text-xs text-white font-bold whitespace-nowrap cursor-pointer"
              >
                <MdDownload size={16} />
                ダウンロード
              </CommonLink>
            </Box>
          )}
        </div>
      </div>

      <Modal opened={opened} onClose={close} centered radius={16}>
        <div className="flex flex-col items-center justify-center gap-8 pb-16 text-center">
          <div className="flex items-center gap-16">
            <Image
              src={NEW_LOGO_IMAGE_PATH_APP_ICON}
              alt="外資就活アプリ"
              width={60}
              height={60}
            />
            <div className="flex flex-col items-start">
              <div className="text-xl font-bold">外資就活ドットコム</div>
              <div className="font-bold">面接対策・インターン・就活アプリ</div>
            </div>
          </div>
          <Image
            src={APP_STORE_QR_CODE_IMAGE}
            alt="アプリダウンロード用QRコード"
            width={160}
            height={44}
          />
          <div className="text-lg text-black-1 font-bold">
            QRコードからアプリをダウンロード
          </div>
        </div>
      </Modal>
    </>
  );
};
